import React from 'react';
import { LinkAction } from '@leverege/molten/routes';
import { RelationshipBreadcrumbs } from '@leverege/molten/imagine';
import { AllowedReducer, Constants } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
// import { DataSources } from '@leverege/ui-attributes'
// import { Context } from '@leverege/plugin'
import ItemScreenWrapper from "./ItemScreenWrapper.js";
import { jsx as _jsx } from "react/jsx-runtime";
const ACTION = 'operatingHoursLocationTab';
const relationships = ['location', 'company.locations', 'organization.companies.locations'];
export default function processRelationship(molten, relationship) {
  if (relationships.includes(relationship.options.path)) {
    const path = `${relationship.urlPath}/:${relationship.blueprint.type}Id/operatingHours`;
    molten.addPlugin('Action', LinkAction.create({
      id: `actions.${relationship.path}.operatingHours`,
      icon: 'fa-solid fa-clock',
      name: 'Operating Hours',
      path,
      matches: {
        use: 'navBar',
        client: 'ItemScreen',
        objectType: relationship.objectType,
        path: relationship.path
      },
      layout: {
        sort: 'e.3',
        sectionName: 'Location Management'
      },
      isPrepared: context => {
        const item = context?.clientProps?.item;
        const location = GlobalState.get()?.models?.lookup?.[item.id];
        const a = AllowedReducer.get(GlobalState.get(), location.id);
        return a[ACTION] != null;
      },
      prepare: async context => {
        const item = context?.clientProps?.item;
        const location = GlobalState.get()?.models?.lookup?.[item.id];
        const systemId = location?.systemId;
        const companyId = location?.data?.company?.id;
        const orgId = location?.data?.organization?.id;
        return GlobalState.dispatch(async (dispatch, getState, {
          api
        }) => {
          let req;
          if (orgId && companyId) {
            req = api.interface(systemId, 'organization').obj(orgId).grp('companies').obj(companyId).grp('locations').obj(location.id);
          } else if (companyId) {
            req = api.interface(systemId, 'company').obj(companyId).grp('locations').obj(location.id);
          } else if (orgId) {
            req = api.interface(systemId, 'organization').obj(orgId).grp('locations').obj(location.id);
          } else {
            req = api.interface(systemId, 'location').obj(location.id);
          }
          const res = await req.update([], {
            test: true
          });
          dispatch({
            type: Constants.ALLOWED_SET,
            resourceId: location.id,
            action: ACTION,
            allowed: res.allowed === true
          });
          return res.allowed === true;
        });
      },
      handles: context => {
        const item = context?.clientProps?.item;
        const location = GlobalState.get()?.models?.lookup?.[item.id];
        const a = AllowedReducer.get(GlobalState.get(), location.id);
        return a[ACTION] === true;
      }
    }));
    molten.addPlugin('Route', {
      id: `route.${relationship.path}.operatingHours`,
      matches: {
        client: 'ItemScreen',
        objectType: relationship.objectType,
        path: relationship.path
      },
      path,
      render: props => {
        return /*#__PURE__*/_jsx(ItemScreenWrapper, {
          relationship: relationship,
          layout: "OperatingHours",
          title: "Operating Hours",
          icon: "fa-solid fa-clock",
          ...props
        });
      }
    });
    molten.addPlugin('Route', {
      id: `route.${relationship.path}.operatingHours:breadcrumbs`,
      matches: {
        client: 'Breadcrumbs'
      },
      exact: true,
      path,
      render: ({
        match,
        ...rest
      }) => {
        const rel = relationship.createItem(match);
        const name = 'Operating Hours';
        const extraCrumbs = [{
          name,
          tooltip: name,
          url: path
        }];
        return /*#__PURE__*/React.createElement(RelationshipBreadcrumbs, {
          match,
          ...rest,
          extraCrumbs,
          relationship: rel
        });
      }
    });
  }
}